<template>
    <tr>
        <td>
            <input type="checkbox" v-model="item['checked']"
                   :disabled="readonly ? true : false"
                   @change="checkboxChange" />
        </td>

        <td>
            <span>
                {{ item['name'] }}
            </span>
        </td>

        <td>
            <span>
                {{ item['formType'] }}
            </span>
        </td>

        <td>
            <span>
                {{ item['note'] }}
            </span>
        </td>

        <td>
            <div v-if="item['link']">
                <!--<a :href="item['link']" target="_blank">{{ $t('seeMore') }}</a>-->
                <!--<button class="copybutton">Button 1</button>-->
                <span>
                    {{ item['link'] }}
                </span>
            </div>
        </td>

        <td style="min-width:220px">
            <date-picker ref="startDatePicker"
                         v-model="item['validFromUtc']"
                         :readonly="readonly"
                         :id="'startDate1'"
                         :min="item.startMinDate"
                         :max="item.startMaxDate"
                         @input="startChange">
            </date-picker>
        </td>

        <td style="min-width:220px">
            <date-picker ref="endDatePicker"
                         v-model="item['validToUtc']"
                         :readonly="readonly"
                         :id="'endDate1'"
                         :min="item.endMinDate"
                         :max="item.endMaxDate"
                         @input="endChange">
            </date-picker>
        </td>
        <td v-if="btns">
            <btns-template :args="templateArgs">
            </btns-template>
        </td>
    </tr>

</template>

<script>
    import bus from '../sidemenu/event-bus';
    import BtnsTemplate from "../../components/grid/CustomGridBtnsTemplate";
    import DatePicker from "../../components/datepicker/DatePicker";
    import { string } from 'jszip/lib/support';

    export default {
        name: 'related-custom-grid-item',
        components: {
            'btns-template': BtnsTemplate,
            'date-picker': DatePicker
        },
        props: {
            item: Object,
            columns: Array,
            btns: Array,
            gridName: {
                type: String
            },
            editableColumns: Array,
            dateFormat: {
                type: string,
                default: ''
            },
            dateColumns: Array,
            readonly: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                templateArgs: { ...this.item, btns: this.btns },
            };
        },
        created() {
            this.bus = bus;
        },
        mounted() {

        },
        methods: {
            checkboxChange() {
                this.bus.$emit('checkbox-changed', this.item, this.gridName);
            },
            isEditable(key) {
                return Array.isArray(this.editableColumns)
                    && this.editableColumns.length > 0
                    && this.editableColumns.indexOf(key) > -1
            },
            isDate(val) {
                if (!this.dateColumns) {
                    return false;
                }
                return this.dateColumns.includes(val);
            },
            startChange(e) {
                let startDate = this.item.validFromUtc;
                let endDate = this.item.validToUtc;

                if (startDate) {
                    startDate = new Date(startDate);
                    startDate.setDate(startDate.getDate());

                    this.item.endMinDate = startDate;
                } else if (endDate) {
                    this.item.startMaxDate = new Date(endDate);
                } else {
                    endDate = new Date();
                    this.item.startMaxDate = endDate;
                    this.item.endMinDate = endDate;
                }
            },
            endChange(e) {
                let startDate = this.item.validFromUtc;
                let endDate = this.item.validToUtc;

                if (endDate) {
                    endDate = new Date(endDate);
                    endDate.setDate(endDate.getDate());

                    this.item.startMaxDate = endDate;
                } else if (startDate) {
                    this.item.endMinDate = new Date(startDate);
                } else {
                    endDate = new Date();
                    this.item.startMaxDate = endDate;
                    this.item.endMinDate = new Date(startDate);
                }
            },
        },
        computed: {

        },
        watch: {
            item: {
                handler: function (newValue, oldValue) {
                    this.bus.$emit('item-changed', newValue, oldValue, this.gridName);
                },
                deep: true
            }
        }
    };
</script>

<style>
</style>
